<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M31.2474 23.8167C33.0883 23.8167 34.5807 22.3243 34.5807 20.4833C34.5807 18.6424 33.0883 17.15 31.2474 17.15C29.4064 17.15 27.9141 18.6424 27.9141 20.4833C27.9141 22.3243 29.4064 23.8167 31.2474 23.8167Z"
      fill="currentColor"
    />
    <path
      d="M19.9974 20.4834C21.8383 20.4834 23.3307 18.991 23.3307 17.15C23.3307 15.3091 21.8383 13.8167 19.9974 13.8167C18.1564 13.8167 16.6641 15.3091 16.6641 17.15C16.6641 18.991 18.1564 20.4834 19.9974 20.4834Z"
      fill="currentColor"
    />
    <path
      d="M8.7474 23.8167C10.5883 23.8167 12.0807 22.3243 12.0807 20.4833C12.0807 18.6424 10.5883 17.15 8.7474 17.15C6.90645 17.15 5.41406 18.6424 5.41406 20.4833C5.41406 22.3243 6.90645 23.8167 8.7474 23.8167Z"
      fill="currentColor"
    />
    <path
      d="M36.6665 17.5666C36.4165 17.5666 36.1665 17.5 35.9498 17.3333L21.1998 6.98331C20.4832 6.48331 19.5165 6.48331 18.7998 6.98331L4.04984 17.3333C3.48318 17.7333 2.69984 17.6 2.31651 17.0333C1.91651 16.4666 2.04984 15.6833 2.61651 15.3L17.3665 4.93331C18.9498 3.83331 21.0665 3.83331 22.6332 4.93331L37.3832 15.2833C37.9498 15.6833 38.0832 16.4666 37.6832 17.0166C37.4332 17.3666 37.0498 17.55 36.6498 17.55L36.6665 17.5666Z"
      fill="currentColor"
    />
    <path
      d="M19.9974 21.7333C16.0974 21.7333 12.9141 24.9166 12.9141 28.8166V34.65C12.9141 35.3333 13.4807 35.9 14.1641 35.9H25.8307C26.5141 35.9 27.0807 35.3333 27.0807 34.65V28.8166C27.0807 24.9166 23.8974 21.7333 19.9974 21.7333Z"
      fill="currentColor"
    />
    <path
      d="M11.2526 34.65V28.8167C11.2526 27.6834 11.4859 26.6 11.8859 25.6167C11.0526 25.2667 10.1359 25.0667 9.16927 25.0667C5.26927 25.0667 2.08594 28.25 2.08594 32.15V34.65C2.08594 35.3334 2.6526 35.9 3.33594 35.9H11.5526C11.3693 35.5167 11.2526 35.1 11.2526 34.65Z"
      fill="currentColor"
    />
    <path
      d="M30.8339 25.0667C29.8672 25.0667 28.9672 25.2667 28.1172 25.6167C28.5172 26.6167 28.7505 27.6834 28.7505 28.8167V34.65C28.7505 35.1 28.6339 35.5167 28.4505 35.9H36.6672C37.3505 35.9 37.9172 35.3334 37.9172 34.65V32.15C37.9172 28.25 34.7339 25.0667 30.8339 25.0667Z"
      fill="currentColor"
    />
  </svg>
</template>